var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIonicIosSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19.005,
    viewBox: "0 0 19 19.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-settings",
    "data-name": "Icon ionic-ios-settings",
    d: "M21.932,14A2.445,2.445,0,0,1,23.5,11.719a9.691,9.691,0,0,0-1.173-2.825,2.478,2.478,0,0,1-.995.213A2.44,2.44,0,0,1,19.1,5.673,9.662,9.662,0,0,0,16.281,4.5a2.443,2.443,0,0,1-4.562,0A9.691,9.691,0,0,0,8.894,5.673,2.44,2.44,0,0,1,6.662,9.107a2.4,2.4,0,0,1-.995-.213A9.9,9.9,0,0,0,4.5,11.724a2.444,2.444,0,0,1,0,4.562,9.691,9.691,0,0,0,1.173,2.825A2.441,2.441,0,0,1,8.9,22.332,9.748,9.748,0,0,0,11.724,23.5a2.438,2.438,0,0,1,4.552,0A9.691,9.691,0,0,0,19.1,22.332a2.443,2.443,0,0,1,3.221-3.221A9.748,9.748,0,0,0,23.5,16.286,2.457,2.457,0,0,1,21.932,14Zm-7.887,3.953A3.958,3.958,0,1,1,18,14,3.957,3.957,0,0,1,14.045,17.953Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicIosSettings);
export default __webpack_public_path__ + "static/media/ionic-ios-settings.7e9f86e9bc3d4b342e6cdefc82172e6b.svg";
export { ForwardRef as ReactComponent };